/**
 * Phase 45 Plan 45-05 — Manager Overview page header.
 *
 * Layout per UI-SPEC §Surface 1 Header layout:
 *   left:  eyebrow ({period.label} · all customers) + h1 "Portfolio"
 *   right: Export CSV (deferred — see button comment) + + New project
 *
 * `+ New project` routes to `/projects/new` per CONTEXT D-08. Export CSV is
 * a stub; full implementation is v7.1 (documented in SUMMARY § Deferred).
 */
import { Link } from 'react-router-dom';
import { Btn } from '../ui/Btn';
import { PlusIcon } from '../ui/icons';
import type { PortfolioPeriodInfo } from '../../services/api/portfolio';

export interface ManagerOverviewHeaderProps {
  period: PortfolioPeriodInfo;
}

export function ManagerOverviewHeader({ period }: ManagerOverviewHeaderProps) {
  return (
    <div className="flex items-end justify-between gap-6">
      <div>
        <div className="text-[10px] uppercase tracking-wider font-medium text-ms-text-muted mb-1">
          {period.label} · all customers
        </div>
        <h1 className="text-[26px] font-semibold tracking-tight text-ms-text-strong">
          Portfolio
        </h1>
      </div>
      <div className="flex items-center gap-2">
        {/*
          EXPORT CSV DEFERRED TO v7.1 — button renders as a static stub; no
          wiring. Surface in SUMMARY "Deferred" section. UI-SPEC §Copy lock
          locks the literal "Export CSV".
        */}
        <Btn variant="secondary" size="sm" type="button" disabled aria-label="Export CSV (coming v7.1)">
          Export CSV
        </Btn>
        <Link
          to="/projects/new"
          className="inline-flex items-center justify-center gap-1.5 bg-ms-orange-dark text-white text-[11.5px] font-medium px-2.5 py-1.5 rounded-md hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-ms-orange/40 focus:ring-offset-1"
        >
          <PlusIcon className="w-3.5 h-3.5" aria-hidden="true" />
          New project
        </Link>
      </div>
    </div>
  );
}
